import { createContext } from 'react';
const BrandContext = /*#__PURE__*/createContext('');
export default BrandContext;